export const state = () => ({
    showLogo: true
})

export const mutations = {}

export const actions = {}
